import { Style } from 'index';

const DisplayLinkStyles: Style = {
    link: { fontSize: '12px', display: 'flex', alignItems: 'center' },
    linkIcon: { fontSize: '14px', marginLeft: '4px' },
};

export default DisplayLinkStyles;
